import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import store from '../../../store';
import {getValueOfFeature} from '../../../util/values';

import {selectHasBase, selectHasBuriedBase, selectIsSingle, selectSpcConfiguration} from '../../../selectors';

@customElement('line-drawing')
export class LineDrawing extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			flex-direction: column;
		}

		.drawing-container {
			display: flex;
		}

		.grounding {
			text-align: center;
			position: relative;
			font: var(--font-specsheet-light);
		}

		.grounding-image {
			width: 70%;
			display: block;
			margin: auto;
			height: auto;
		}

		.single-image {
			height: auto;
			width: 90%;
			margin-bottom: var(--specsheet-small-gap);
		}

		trans-label {
			font-size: 3.9cqw;
		}
	`
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.spcConfiguration = selectSpcConfiguration(state);
	}


	render() {
		const s = this.state;
		return html`

			<div class="drawing-container">
				${when(!selectIsSingle(s), () => html`
					<svg-measure></svg-measure>
				`)}
				${when(selectIsSingle(s), () => html`
					<img class="single-image" alt=""
						 src="${this.status.host + this.status.baseUrl + this.status.epimAssetsUrl}/images/line-single/${getValueOfFeature('shared::ProductType::HS_HousingType', this.spcConfiguration)}-${getValueOfFeature('root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEngineModuleSize', this.spcConfiguration)}.svg"/>
				`)}
			</div>
			<div class="grounding-container">
				${when(!selectIsSingle(s) && selectHasBase(s) && !selectHasBuriedBase(s), () => html`
					<div class="grounding">
						<img class="grounding-image" alt=""
							 src="${this.status.host + this.status.baseUrl + this.status.epimAssetsUrl}/images/line-drawing/${getValueOfFeature('root::Poles::Pole::Basic::HS_Base', this.spcConfiguration)}.svg"/>
						<trans-label key="root::Poles::Pole::Basic::HS_Base" context="FV.S"></trans-label>
					</div>
				`)}
			</div>
		`;
	}
}
